import Link from 'next/link'

import { Text } from '@wartek-id/text-v1'
import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'

import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'

import type { SchoolBadgeStatus } from './type'
import type { KinerjaRoleType } from 'types/kinerja'

export type SchoolItemProps = {
  itemsToSend: number
  name: string
  npsn: string
  role: KinerjaRoleType
  status: SchoolBadgeStatus
}

export function SchoolItem({
  itemsToSend,
  name,
  npsn,
  role,
  status,
}: SchoolItemProps) {
  return (
    <li className="space-y-4 p-6 rounded-md border border-gray-20">
      <div className="flex items-start justify-between space-x-4">
        <div className="space-y-1">
          <Text variant="heading-sm" as="h3">
            {name}
          </Text>
          <Text color="subdued">{npsn}</Text>
          <Text color="subdued">
            {role == 'KS_DEFINITIF'
              ? 'Kepala Sekolah Definitif'
              : 'Plt. Kepala Sekolah'}
          </Text>
        </div>

        <Cta status={status} schoolName={name} npsn={npsn} />
      </div>

      <StatusBadge status={status} itemsToSend={itemsToSend} />
    </li>
  )
}

type StatusBadgeProps = {
  status: SchoolBadgeStatus
  itemsToSend: number
}
function StatusBadge({ status, itemsToSend }: StatusBadgeProps) {
  switch (status) {
    case 'ALL_SENT':
      return <Badge variant="success">Semua Predikat sudah dikirim</Badge>
    case 'UNAVAILABLE':
      return (
        <Badge variant="informational">
          Predikat Kinerja Organisasi masih dalam proses
        </Badge>
      )
    case 'NOT_READY_TO_SEND':
      return (
        <Badge className="!bg-gray-20">
          Belum ada Predikat yang siap dikirim
        </Badge>
      )
    case 'READY_TO_SEND':
      return (
        <Badge variant="warning">{itemsToSend} Predikat siap dikirim</Badge>
      )
    default:
      return null
  }
}

type CtaProps = {
  status: SchoolBadgeStatus
  schoolName: string
  npsn: string
}
function Cta({ npsn, status, schoolName }: CtaProps) {
  const ctaText =
    status === 'READY_TO_SEND' ? 'Lakukan Penetapan' : 'Cek Penetapan'
  const ctaColor = status === 'READY_TO_SEND' ? 'black' : 'white'
  const isCtaDisabled = status === 'UNAVAILABLE'

  return (
    <Link
      href={`${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/predikat-kinerja-tahunan/${npsn}`}
      passHref
    >
      <Button
        aria-label={`${ctaText} ${schoolName}`}
        disabled={isCtaDisabled}
        color={ctaColor}
        as="a"
        type={undefined}
      >
        {ctaText}
      </Button>
    </Link>
  )
}
